import { css } from '@emotion/css';
import { useUrls } from 'Shared/UrlProvider';
import { usePageDetails } from 'Shared/frontend/PageDetailsProvider';
import { calcHeight } from 'Shared/frontend/widgets/HeightUtils';


export function ImageBlock(P)
{
	const pageDetails = usePageDetails();

	const size = () => {
		let ret = P.display.size ?? 'medium';
		return P.image?.formats?.[ret] ? ret : 'full';
	};

	const imageUrl = () => useUrls().createVenueImageUrl(
		P.image?.hash ?? '',
		P.image,
		pageDetails.imageFolder,
		size()
	);

	const wrapStyle = () => css({
		width: '100%',
		...calcHeight(P.display),
	
		/* Probably rare case where the images are small and not being stretched */
		display: 'flex',
		/*
			COULD parameterise these, but a bit of an edge case. Note that P.display.position is intended for
			maintaining focal point WITHIN an image, so probably shouldn't use this value here.
		*/
		justifyContent: 'center', 
		alignItems: 'center',
	});

	const imageStyle = () => css({
		maxWidth: '100%',
		maxHeight: '100%',

		width: P.display.child ? 'initial' : '100%',
		height: P.display.child ? 'initial' : '100%',

		objectFit: P.display.fit ?? 'cover',
		objectPosition: P.display.position ?? 'center',
	});

	return (
		<div class={css(wrapStyle(),P.styling.css ?? {})}>
			<img src={imageUrl()} alt='' class={imageStyle()} />
		</div>
	);
}

